'use strict';

import {snake_case} from "../text/string.js";

export const Token_list = function (ids) {
	let ids_array = [],
	self = this,
	parse = function (id, fn_name, cb) {
		const search = id.toString();
		if (search.split(' ').length > 1) {
			throw new Error("Failed to execute '" + fn_name + "' on 'Token_list': The token provided ('" + search + "') contains HTML space characters, which are not valid in tokens.');");
		}
		else {
			cb(search);
		}
	};

	function trigger_attr_change ()
	{
		if (self.token_changed && typeof self.token_changed === 'function') {
			self.token_changed(ids_array.toString());
		}
	}

	if (ids && typeof ids === 'string') {
		ids_array = ids.split(' ');
	}
	self.item = function (index) {
		return ids_array[index];
	};

	self.length = function () {
		return ids_array.length
	};

	self.contains = function (id) {
		parse(id, 'contains', function (search) {
			return ids_array.indexOf(search) !== -1;
		});
	};

	self.add = function (id) {
		parse(id, 'add', function (search) {
			if (ids_array.indexOf(search) === -1) {
				ids_array.push(search);
			}
			trigger_attr_change();
		});
	};

	self.remove = function (id) {
		parse(id, 'remove', function () {
			ids_array = ids_array.filter(function (item) {
				return item !== id;
			});
			trigger_attr_change();
		});
	};

	self.toggle = function (id) {
		parse(id, 'toggle', function (search) {
			if (!self.contains(search)) {
				self.add(search);
			}
			else {
				self.remove(search);
			}
		});
	};

	self.token_changed = null;

	self.toString = function () {
		let tokens = '',
		i;
		if (ids_array.length > 0) {
			for (i = 0; i < ids_array.length; i = i + 1) {
				tokens = tokens + ids_array[i] + ' ';
			}
			tokens = tokens.slice(0, tokens.length - 1);
		}
		return tokens;
	};
};

export const emplace_token_list = function (element, prop, initial_values) {
	let init_values = initial_values || element.getAttribute(prop),
	MutationObserver = window.MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver,
	observer,
	config,
	cancelMutation = false;

	function create_token_list (values)
	{
		const list = new Token_list(values);
		list.tokenChanged = function () {
			element.setAttribute(prop, element[prop].toString());
			cancelMutation = true;
		};

		element[snake_case(prop)] = list;
	}

	create_token_list(init_values);

	observer = new MutationObserver(function (mutation) {
		let i,
		mutation_record,
		new_attr;
		if (mutation.length > 0 && !cancelMutation) {
			for (i = 0; i < mutation.length; i = i + 1) {
				mutation_record = mutation[i];
				if (mutation_record.attributeName === prop && element[prop]) {
					new_attr = element.getAttribute(prop);
					create_token_list(new_attr);
				}
			}
		}
		cancelMutation = false;
	});

	config = {
		attributes: true
	};
	observer.observe(element, config);
};